import { Component } from 'react';
import styled from 'styled-components';
import { Button, ButtonVariation } from '../Button/Button';
import { ButtonToolbar } from '../ButtonToolbar/ButtonToolbar';

const FormElement = styled.form`
  display: flex;
  flex: 1;
`;

const FormElementInner = styled.div`
  width: 100%;
  flex: 1;
`;

const FormItemsElement = styled.div`
  display: flex;
  flex-direction: column;
`;

const FooterElement = styled.div`
  margin-top: 30px;
  padding: 10px;
  padding-top: 10px;
`;

export interface IProps {
  onSubmit?: () => void;
  onCancel?: () => void;
  submitButtonLabel?: string;
  cancelButtonLabel?: string;
  submitButtonType?: ButtonVariation;
  cancelButtonType?: ButtonVariation;
}

export interface IState {
  valid: boolean;
  badFormItems: any[];
}

export class Form extends Component<IProps, IState> {
  public state: IState = {
    valid: true,
    badFormItems: [],
  };

  public render() {
    return (
      <FormElement data-testid="FormElement" autoComplete="off" noValidate={true}>
        <FormElementInner>
          <FormItemsElement>{this.props.children}</FormItemsElement>
          {(this.props.onSubmit || this.props.onCancel) && (
            <FooterElement>
              <ButtonToolbar align="right">
                {this.props.onCancel && (
                  <Button
                    variation={this.props.cancelButtonType || 'secondary'}
                    onClick={this.handleCancelButtonClicked}
                  >
                    {this.props.cancelButtonLabel || 'Cancel'}
                  </Button>
                )}
                {this.props.onSubmit && (
                  <Button variation={this.props.submitButtonType || 'primary'} onClick={this.handleSubmitButtonClicked}>
                    {this.props.submitButtonLabel || 'Submit'}
                  </Button>
                )}
              </ButtonToolbar>
            </FooterElement>
          )}
        </FormElementInner>
      </FormElement>
    );
  }

  private handleCancelButtonClicked = (e: any) => {
    e.preventDefault();
    if (this.props.onCancel) {
      this.props.onCancel();
    }
  };

  private handleSubmitButtonClicked = (e: any) => {
    e.preventDefault();

    if (this.props.onSubmit) {
      this.props.onSubmit();
    }
  };
}
